export function arraySwapItems<T>(array: T[], index1: number, index2: number): void {
  if (index1 < 0 || index1 >= array.length)
    return;
  if (index2 < 0 || index2 >= array.length)
    return;
  if (index1 === index2)
    return;
  const tmp = array[index1];
  array[index1] = array[index2];
  array[index2] = tmp;
}
